exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root{--reach-combobox:1}[data-reach-combobox-popover]{border:1px solid rgba(0,0,0,.25);background:rgba(255,255,255,.99);font-size:85%}[data-reach-combobox-list]{list-style:none;margin:0;padding:0;user-select:none}[data-reach-combobox-option]{cursor:pointer;margin:0;padding:.25rem .5rem}[data-reach-combobox-option][aria-selected=true]{background:#f1f2f4}[data-reach-combobox-option]:hover{background:#e9ebed}[data-reach-combobox-option][aria-selected=true]:hover{background:#e3e5e8}[data-suggested-value]{font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/@reach/combobox/styles.css
// module id = 17
// module chunks = 0